import { createServiceType } from '@tv2-player/service-container/src/serviceContainer';

export const LogMetadataProvider = createServiceType<LogMetadataProvider>();

export interface LogMetadataProvider {
  getMetadata(): any;
}
